<template>
  <div>
    <header>
          <div class="headerOne">
                 <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)">   -->
          </div>
            <span class="myOne">我的个人信息</span>
    </header>
    <div class="integral">
        <p >我的积分</p>
        <div>{{jifenOne}}</div>
    </div>
    <div class="ulOne">
        <ul>
            <li>
                <span class="nameOne">会员等级</span>
                <span class="nameTo">
                    <span>VIP{{vipLevelOne}}</span>
                    </span>
            </li>
            <li>
                <span class="nameOne">会员特权</span>
                <div class="nameTo nameOld">
                    <!-- 占时没有 写死 -->
                    <span>买单{{zhekouOne}}折</span>
                    <span>{{other}}</span>
                    <!-- <span>可参加店内的其他优惠活动</span>
                    <span>先算折扣,折后算活动优惠</span> -->
                    </div> 
            </li>
        </ul>
    </div>
 <p class="ask">本店VIP特权说明</p>
 <span class="askOne" @click="goDetail">更多</span>
 <div class="ulOne">
        <ul>
            <li class="other" v-for="(item,index) in vipArry" :key="index">
                <span class="nameOne">{{item.vipName}}特权</span>
                <div class="topOne">{{item.other}}</div>
            </li>
        </ul>
    </div>
<footer>
    以上内容由商家提供,如有疑问请详讯商家。
</footer>
  </div>


</template>
<script>
import axios from "axios";
import { Popup ,Toast } from 'mint-ui';

    export default{
        data(){
            return{
               InfoOne:this.$route.query.InfoOne,  //sid      
               jifenOne:this.$route.query.jifenOne,  //积分
                vipLevelOne: this.$route.query.vipLevelOne,  //vip等级
                vipArry:[],
                vipArryOne:[],
                 cTypeIdOn:this.$route.query.cTypeIdTnre,    //cTypeId
                // vipNum:"",
                zhekouOne:"",
                other:"",
                Toast: Toast({
                    message: '加载中...',
                    position: 'middle',
                    duration: -1
                    }),
            }
        },
        computed:{
            wsWbsocket(){
                return this.$store.state.wsWbsocket;
                }
        },
        methods:{
            //点击跳转到goDetail页面
          goDetail()
          {
              this.$router.push({
                      path:"/alldeil",
                 query:{
                  vipArry:this.vipArryOne 
                 }  
              })
          },
          checkHttpReturn(id)
          {
                if(httpSendQue[id]==0)
                {
                    var  self=this;
                    setTimeout(() => {
                            if (self && !self._isDestroyed)
                                self.checkHttpTimeOut();
                        }, newConfigTime);

                }
                else
                {
                    delete httpSendQue[id];
                }
           },
            checkHttpTimeOut()
            {
                if(httpSendQue[id]==0)
                {
                    //  隐藏加载中
                    this.Toast.close()
                    Toast({
                            message: '网络不给力',
                            position: 'middle',
                            duration: 3000
                        })
                    

                }
                else
                {
                    //删除数组中的id
                    delete httpSendQue[id];

                }
            },
                
          websocketOne(){
                var  self=this;     
                id= getHttpSendId ();
                getArry(id)   //将生成ID放入数组  
                setTimeout(() => 
                {
                    if (self && !self._isDestroyed)
                        self.checkHttpReturn(id);
                }, configTime);      
                var newInfo=this.$route.query.InfoOne;
                  axios.get(vipSetting+"&uid="+uid+"&sign="+sign+"&mode="+mode+"&sid="+newInfo)
                    .then(res=>{  
                        httpSendQue[id] = 1; 
                        this.Toast.close();
                        if(res.data.s==0){  
                            this.vipArryOne=res.data.vipSets;
                            this.vipArry=res.data.vipSets
                            // console.log(this.vipArry.vip4)
                            var vipLevelOne="vip"+this.vipLevelOne
                            console.log(vipLevelOne)
                            console.log(this.vipArry)
                            console.log(typeof(vipLevelOne))
                            var allNew=this.vipArry[vipLevelOne]
                            console.log(allNew)
                            this.zhekouOne=(allNew.zheKou)/10
                            this.other=allNew.other
                            let arr=[];
                            for(var i in this.vipArry){
                                arr.push(this.vipArry[i])   
                            }
                            this.vipArry=arr.slice(this.vipLevelOne)
                            }
                        
                        })
                    .catch(error=>{
                        this.Toast.close()
                        Toast({
                              message: '网络不给力',
                              position: 'middle',
                              duration:2000
                            })           
                                })
          }
        },
    created()
    {
         
        },
    mounted()
    {
         this.websocketOne()
    },
    destroyed()
    {
        this.Toast.close()
    
    }

    }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.8rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header{
    height:1.6rem;
    width: 100%;
    position: relative;
}
 .headerOne{
     font-size: 0;  
     width: 20%;
     
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem;
    
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .myOne{
      font-size: 0.55rem;
      position: absolute;
      top: 0.42rem;
      left:3.5rem;
      }
      .integral{
          width: 100%;
          height: 4rem;
          background: gray;
          background-image: url("../../assets/images/bgOne.png");
          background-repeat: no-repeat;
          background-size: 100% 4rem
      }
      .integral p{
          font-size: 0.55rem;
          color: white;
        padding: 0.2rem 0 0 0.3rem;
      }
       .integral div{
           color: white;
           font-size: 0.75rem;
          text-align: center;
           padding: 0.6rem 0.3rem 0 0;
       }
       .ulOne{
           width: 90%;
           margin: 0 auto;
           margin-bottom: 0.5rem
       }
.ulOne ul li{
 font-size: 0.55rem;
 margin: 0.28rem 0.4rem 0.3rem 0;
    position: relative;
    color: #333333;
}
.ulOne ul li .nameTo{
    color: rgba(0,0,0,0.5);
    margin-left: 0.3rem
}
.nameOne{
    vertical-align: top;
    margin-right:1rem
}
.nameOld span{
display: block;
width: 5rem
}
.nameOld :last-child{
display: block;
width: 5rem;
color: pink;
padding-top: 0.25rem
}
.ulOne ul li div{
    display: inline-block;
    color: rgba(0,0,0,0.5);
    width:4.3rem;
    margin-left:3.5rem
}
.youhui{
    display: inline-block;

      vertical-align: top;
}
.ulOne ul li:nth-child(4) span{
position: absolute;
top: 0;
margin-right: 0.4rem
}
.ask{
    font-size: 0.55rem;color: rgba(0, 0, 0, 0.9);
    margin-left: 0.3rem;
    font-weight: bold;
    margin-bottom:0.5rem;
    display: inline-block
}
.askOne{
    font-size: 0.5rem;
    color: #0875c4;
    margin-left: 2.5rem
}
footer{
    color: rgba(0, 0, 0, 0.2);
    font-size: 0.45rem;
   text-align: center;
   margin-bottom: 1rem;
 
}
.topOne{
    position: absolute;
    left: 0;
    margin-left: 0.5rem
}
.other{
    height: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/infor/infor.vue